/**
 * Strings of the 404 and error screens that `shared/messages/vi.ts` does not carry yet. The two
 * lines the older tests look for (`error.notFound`, `error.generic`) stay in `vi.ts` and are reused.
 */
export const ROUTE_ERROR_MESSAGES = {
  'routeError.notFoundLead': 'Đường dẫn có thể đã đổi hoặc gõ sai. Hãy về trang chủ để chọn lại.',
  'routeError.title': 'Màn hình này gặp sự cố',
  'routeError.retry': 'Thử lại',
} as const;

export type RouteErrorMessageCode = keyof typeof ROUTE_ERROR_MESSAGES;

export function rt(code: RouteErrorMessageCode): string {
  return ROUTE_ERROR_MESSAGES[code];
}
